import {PlantillaCorreoModel} from "@/models/generales/plantilla-correo";
import PlantillaCorreoAPI from "@/services/generales/plantillaCorreo";
import * as wysiwygMethods from '@/helpers/wysiwyg-methods';
import * as R from "ramda";
import {scrollToForm} from '@/helpers/form-scroll-to';

function evaluateModelChangedFlag(data){
  if(!data && typeof data === "boolean") return data
  if(data && typeof data === "object") return data.length>=1;
}
const modelIsModified = R.curry((mod)=>R.compose(evaluateModelChangedFlag,mod.changed)());

//Base State
function BaseStateForm(){}
// States' consctructors
export function InitialState(self){
  //Assing context
  this.data = self;
  //Reset Models and validators
  this.resetModel();
  this.resetValidators();
  //View configuration
  this.data.view.elem.button.clear.visible=true;
  this.data.view.elem.button.audit.visible=false;
  this.data.view.elem.input.clave.visible=true;
  this.data.view.elem.input.clave.disabled=false;
  this.data.view.elem.button.submit.class.current = this.data.view.elem.button.submit.class.save;
  this.data.view.elem.button.submit.data.title.current = this.data.view.elem.button.submit.data.title.save;

}
export function EditingState(self, plantillaCorreo){
  let {clave
    , descripcion
    , remitente
    , multiListPerfilesDestinatarios
    , destinatariosOpcionales
    , cc
    , cco
    , asunto
    , cuerpo
    , status, version} = plantillaCorreo;
  
  this.data = self;
  this.data.view.elem.button.clear.visible=true;
  this.data.view.elem.button.audit.visible=true;
  this.data.view.elem.input.clave.visible=true;
  this.data.view.elem.input.clave.disabled=true;
  this.data.view.elem.button.submit.class.current = this.data.view.elem.button.submit.class.update;
  this.data.view.elem.button.submit.data.title.current = this.data.view.elem.button.submit.data.title.update;

  let arrayValues = [];
  if(multiListPerfilesDestinatarios != null){
    let perfiles = multiListPerfilesDestinatarios.split(',');
    this.data.view.elem.select.groups.options.forEach(function(option){ 
      if(perfiles.includes(option.code+''))
        arrayValues.push({'name':option.name, 'code':option.code});
    });
  }
  multiListPerfilesDestinatarios=arrayValues;

  this.data.plantillaCorreo = new PlantillaCorreoModel({clave
    , descripcion
    , remitente
    , multiListPerfilesDestinatarios
    , destinatariosOpcionales
    , cc
    , cco
    , asunto
    , cuerpo
    , status, version});
  this.resetValidators();
}
export function SavedState(self, {clave
  , descripcion
  , remitente
  , multiListPerfilesDestinatarios
  , destinatariosOpcionales
  , cc
  , cco
  , asunto
  , cuerpo
  , status, version}){}
// Setting Base as prototype
InitialState.prototype = Object.create(BaseStateForm.prototype);
EditingState.prototype = Object.create(BaseStateForm.prototype);
SavedState.prototype   = Object.create(BaseStateForm.prototype);
// Setting his own constructor instead of constructor's prototype
InitialState.prototype.constructor = InitialState;
EditingState.prototype.constructor = EditingState;
SavedState.prototype.constructor   = SavedState;
//Base skeleton
BaseStateForm.prototype.save   = function(){console.log("save no implementado"); return Promise.resolve()}
BaseStateForm.prototype.edit   = function(){console.log("edit no implementado"); return Promise.resolve()}
BaseStateForm.prototype.submit = function(){console.log("submit no implementado"); return Promise.resolve()}
BaseStateForm.prototype.clear = function(){Object.setPrototypeOf(this.data.state, new InitialState(this.data));}
BaseStateForm.prototype.audit = async function({clave, tabla, descripcion, revision}){
  try{
    auditoriaStates.EditingState({clave, tabla, descripcion, revision});
  }catch(error){
    console.log(error)
  }
}
BaseStateForm.prototype.resetModel = function(){this.data.plantillaCorreo = new PlantillaCorreoModel();}
BaseStateForm.prototype.resetValidators = function(){this.data.$v.$reset();}
BaseStateForm.prototype.isDisableButtonSubmit = function(){return this.data.hasErrors(this.data.$v.plantillaCorreo)|| this.data.view.action.submit.busy}

//Initial State Implementation
InitialState.prototype.submit = async function({clave
  , descripcion
  , remitente
  , multiListPerfilesDestinatarios
  , destinatariosOpcionales
  , cc
  , cco
  , asunto
  , cuerpo
  , status, version}){
  try{
    if(!this.data.isAllValid(this.data.$v)){
      scrollToForm(this.data);
      return false;
    }
    try
    { 
      multiListPerfilesDestinatarios = 
      multiListPerfilesDestinatarios.map(({code}) => code).toString();
    }
    catch(error)
    {
      console.log(error);
    }
    const contentImageReplaced = await wysiwygMethods.replaceImageSourceById(cuerpo);
    
    this.data.view.action.submit.busy=true;
    const response = await PlantillaCorreoAPI.save({clave
      , descripcion
      , remitente
      , multiListPerfilesDestinatarios
      , destinatariosOpcionales
      , cc
      , cco
      , asunto
      , cuerpo:contentImageReplaced.content
      , imagenes:contentImageReplaced.images
      , status, version});
    this.data.view.action.submit.busy=false;
    this.resetModel();
    this.resetValidators();
    this.data.$refs.tablePlantillaCorreo.refreshData();
    return response;
  }catch(error){
    return error;
  }
}
//Editing State Implementation
EditingState.prototype.submit = async function(plantillaCorreo){
  let {clave
    , descripcion
    , remitente
    , multiListPerfilesDestinatarios
    , destinatariosOpcionales
    , cc
    , cco
    , asunto
    , cuerpo
    , status, version}=plantillaCorreo;
  try{
    if(!this.data.isAllValid(this.data.$v)){
      scrollToForm(this.data);
      return false;
    }
    try
    { 
      multiListPerfilesDestinatarios = 
      multiListPerfilesDestinatarios.map(({code}) => code).toString();
    }
    catch(error)
    {
      console.log(error);
    }
    this.data.view.action.submit.busy=true;

    const contentImageReplaced = await wysiwygMethods.replaceImageSourceById(cuerpo);

    const response = await PlantillaCorreoAPI.update({clave
      , descripcion
      , remitente
      , multiListPerfilesDestinatarios
      , destinatariosOpcionales
      , cc
      , cco
      , asunto
      , cuerpo:contentImageReplaced.content
      , imagenes:contentImageReplaced.images
      , status, version}); 
    this.data.$refs.tablePlantillaCorreo.refreshData();
    this.data.view.action.submit.busy=false;
    Object.setPrototypeOf(this.data.state, new InitialState(this.data));
    return response;
  }catch(error){
    console.log(error)
    return error;
  }
  console.log("actualizando datos existentes")
}
EditingState.prototype.isDisableButtonSubmit = function(){
  
  return this.data.hasErrors(this.data.$v.plantillaCorreo) 
    || this.data.view.action.submit.busy
    || !modelIsModified(this.data.plantillaCorreo)
}

//Saved State Implementation




// WEBPACK FOOTER //
// ./src/views/generales/plantillaCorreo/plantilla-correo-states.js